var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPagerduty = function SvgPagerduty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#06ac38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.57 372.751h73.287v133.25H83.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M359.585 30.429C320.245 9.489 292.961 6 228.557 6H83.57v303.3h144.353c57.424 0 100.253-3.49 138.007-28.554 41.244-27.284 62.5-72.652 62.5-125 0-56.79-26.332-102.157-68.845-125.317M244.737 245.848h-87.88V71.038l82.804-.634c75.508-.952 113.262 25.698 113.262 85.977 0 64.72-46.637 89.467-108.186 89.467"
  }))));
};
export default SvgPagerduty;